import { memo } from 'react';

interface LinkProperties {
    targetUri: string;
    text: string;
}

export const Link = memo((props: LinkProperties) => {
    const { targetUri, text } = props;
    return (
        <a href={targetUri} target='_blank' rel='noopener noreferrer' onClick={event => event.stopPropagation()}>
            {text}
        </a>
    );
});
